// Top-level `serpProbes/{probeId}` collection.
//
// A "probe" is a one-off DataForSEO pull for a (keyword, location) pair
// that isn't tied to a tracked client. PMs use this to capture Google's
// current SERP for a prospect during onboarding — see Phase 11 §B.
//
// Probes are NOT a substitute for tracked rankings. They:
//   - live outside the per-client tree (no client/subject/keyword path)
//   - auto-delete after 30 days via Firestore TTL on `expiresAt`
//   - are staff-readable / Functions-write only
import { z } from 'zod';
import { TimestampLike } from './common.js';
import { OrganicResult, KnowledgePanelResult, PAAResult, SerpModule } from './ranking.js';

export const SerpProbeDoc = z.object({
  keyword: z.string().min(1).max(200),
  locationCode: z.number().int(),
  locationName: z.string().min(1),
  device: z.enum(['desktop', 'mobile']).default('desktop'),
  pulledAt: TimestampLike,
  organic: z.array(OrganicResult).max(100),
  knowledgePanel: KnowledgePanelResult.optional(),
  paa: z.array(PAAResult).optional(),
  modules: z.array(SerpModule).max(24).optional(),
  costUsd: z.number().nonnegative(),
  requestedBy: z.string().min(1), // uid of the staff member who triggered it
  expiresAt: TimestampLike, // Firestore TTL drops this row after this instant
});
export type SerpProbeDoc = z.infer<typeof SerpProbeDoc>;
